

$(function () {
   if($(".page--rheemteam").length != 0){

       $('.TeamList_item').on("click", function(e){
           $("#profilOverwiew").html($(this).html());
       });
       $('.TeamList_item').eq(0).click();



       var $grid = $('.TeamList').isotope({
           itemSelector: '.TeamList_filter',
       });


       $('.filterContainer').on( 'change', 'input', function() {
           // get filter value from input value
           console.log('test');
           var filterValue = this.value;
           // use filterFn if matches value
           //filterValue = filterFns[ filterValue ] || filterValue;
           $grid.isotope({ filter: filterValue });
       });
   }
});